import { render } from "./SwitchReceipt.vue?vue&type=template&id=22c06a13&scoped=true"
const script = {}

import "./SwitchReceipt.vue?vue&type=style&index=0&id=22c06a13&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c06a13"]])

export default __exports__